  // export default CustomMasterForm;
  import React, { useState, useImperativeHandle, forwardRef } from "react";
  import { Box } from "@mui/material";
  import CustomMasterSchema from "../../../../Config/Export/CreateNewCustomer/CustomeDetails/CustoMaster/customMaster";
  import FormGenerator from "@/Utils/FormGenerator/FormGenerator";
  import { useLazyGetCustomMasterQuery,useCreateCustomMasterMutation } from "@/redux/Organization/CreateNewCustomer/CustomeDetails/CustomMaster/CustomDetails";
  import { useUser } from "../../../../Context/UserContext";

  // Wrap component in forwardRef
  const CustomMasterForm = forwardRef(
    ({ formData, handleSave,isDisabled }, ref) => {
      const values = formData?.customdetails || {};  // << Load API values

      return (
        <Box px={2}>
          <FormGenerator
            compKey="CustomDetails"
            schema={CustomMasterSchema}
            initialValues={values}
            ref={ref}
            onSubmit={handleSave}   // << Allow save
            isDisabledAll={isDisabled}
          />
        </Box>
      );
    }
  );


  export default CustomMasterForm;
